import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener('cart:updated', this.#handleCartUpdate);
    
    // Zusätzliche Event-Listener für Buy Buttons
    this.#setupBuyButtonListeners();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('cart:updated', this.#handleCartUpdate);
    
    // Cleanup Buy Button Listeners
    this.#cleanupBuyButtonListeners();
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      
      // Zeige Upgrade-Nachricht nach automatischem Öffnen
      setTimeout(() => {
        this.#showUpgradeMessage();
      }, 800);
    }
  };

  #handleCartUpdate = (event) => {
    // Nicht mehr benötigt
  };

  #setupBuyButtonListeners() {
    // Nicht mehr benötigt
  }

  #cleanupBuyButtonListeners() {
    // Cleanup wird automatisch durch Event-Listener gemacht
  }

  #showUpgradeMessage() {
    const upgradeMessage = document.getElementById('cart-upgrade-message');
    if (!upgradeMessage) return;
    
    // Prüfe ob es das erste Produkt ist (cart.item_count === 1)
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count === 1) {
          upgradeMessage.style.display = 'block';
        } else {
          // Verstecke Nachricht wenn nicht mehr das erste Produkt
          upgradeMessage.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
    
    // Zeige Upgrade-Nachricht wenn Drawer geöffnet wird
    setTimeout(() => {
      this.#showUpgradeMessage();
    }, 800);
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// Test-Funktion für Upgrade Message
window.testUpgradeMessage = () => {
  console.log('Testing upgrade message...');
  const upgradeMessage = document.getElementById('cart-upgrade-message');
  if (upgradeMessage) {
    upgradeMessage.style.display = 'block';
    console.log('Upgrade message shown!');
  } else {
    console.log('Upgrade message element not found!');
  }
};
